<p-confirmDialog key="importholidayconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="importholiday" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Border-->
<div>
	<!--Instructions-->
	<div class="InstructionDiv">
		<p>
			<span style="font-weight: bold">Overview:</span> This popup lets you pick which days are "holidays" or special days where school is closed on a
			weekday or open on the weekend. You can also update the rest of the days to be open during the week, and closed on weekends. Steps:
		</p>
		<br />
		<ol>
			<li>Use Excel to make a list of holidays</li>
			<li>Save it as a Tab-Delimited Text file or .CSV</li>
			<li>In the menu below, select the file to import</li>
			<li>Select which columns to import</li>
			<li>If you want to make all the non-holidays open (or closed if it's a weekend) fill out the start and end date options below</li>
			<li>NOTE: For Start/End Date you will probably want to update from now to the end of the school year, or end of the semester.</li>
		</ol>
	</div>

	<div class="HorizontalSpacer"></div>

	<!--Select File-->
	<div>
		<h4>Upload list of Holidays</h4>

		<!--Format-->
		<div class="ColumnsOuterDiv">
			<label>Columns:</label>

			<div class="ColumnsMiddleDiv">
				<div>Date<br />(Ex. 1/1/25)</div>
				<div class="SpacerCol"></div>
				<div>Open <span class="InfoText">(Optional, Defaults to Closed)</span><br />(Yes/No or Closed/Open)</div>
			</div>
		</div>

		<!--Select File-->
		<div class="FileUploadDiv">
			<label *ngIf="FileName?.length > 0" class="InfoText">{{ FileName }}</label>

			<input id="ImportFileInput" name="ImportFileInput" type="file" style="display: none" accept=".txt, .csv" (change)="onFileToImportChange($event)" />
			<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onUploadFile()">Upload File</button>
		</div>

		<div class="UpdateDaysDiv">
			<label>Skip First Line:</label>
			<input [disabled]="IsLoading() == true" type="checkbox" class="CHK" [(ngModel)]="SkipFirstLine" (ngModelChange)="onSkipFirstLineChange($event)" />
		</div>

		<!--Preview-->
		<div *ngIf="ShowColumnTable == true">
			<caass-calendar-import-column-table [ImportStatusID]="ImportStatusID" [lstColumnTable]="lstColumnTable"></caass-calendar-import-column-table>
		</div>
	</div>

	<div class="HorizontalSpacer"></div>

	<!--Update Normal Days-->
	<h4>Make all weekdays open?</h4>

	<div class="UpdateDaysDiv">
		<label>Update Normal Days<br />(Can overwrite existing holidays):</label>
		<input [disabled]="IsLoading() == true" type="checkbox" class="CHK" [(ngModel)]="OverwriteExisting" />

		<label>Start Date:</label>
		<p-calendar
			[disabled]="IsLoading() == true || OverwriteExisting == false"
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="StartDate"
			name="StartDate"
			appendTo="body"
		></p-calendar>

		<label>End Date:</label>
		<p-calendar
			[disabled]="IsLoading() == true || OverwriteExisting == false"
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="EndDate"
			name="EndDate"
			appendTo="body"
		></p-calendar>
	</div>

	<div class="HorizontalSpacer"></div>

	<!--Schools-->
	<h4>Select Schools</h4>

	<div class="UpdateDaysDiv">
		<label>Apply to All Schools:</label>
		<input [disabled]="IsLoading() == true" type="checkbox" class="CHK" [(ngModel)]="AllSchools" />
	</div>

	<div *ngIf="AllSchools == false">
		<h4>Select School(s)</h4>

		<div>
			<caass-district-calendar-school-table [lstSchool]="lstSchool"></caass-district-calendar-school-table>
		</div>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Import</button>
	<button [disabled]="Processing == true" class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
